import { useState } from 'react';

const useTooltip = (initialState = false) => {
  const [showTooltip, setShowTooltip] = useState(initialState);

  const displayTooltip = (duration: number) => {
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), duration);
  };

  return { showTooltip, displayTooltip };
};

export default useTooltip;
